/** Las 8 direcciones de Club Penguin, en orden trigonométrico desde el este. */
export const FACINGS = ["e", "se", "s", "sw", "w", "nw", "n", "ne"];
/** Índice de `s` en FACINGS: la dirección por defecto, de cara a la cámara. */
export const DEFAULT_FACING_INDEX = 2;
/**
 * Espejo horizontal de cada dirección. Permite dibujar sólo un costado y obtener
 * el otro gratis: cinco imágenes cubren las ocho direcciones.
 *
 * `n` y `s` no aparecen porque son simétricas de frente: espejarlas no aporta nada.
 */
export const MIRRORED_FACING = {
    e: "w",
    w: "e",
    ne: "nw",
    nw: "ne",
    se: "sw",
    sw: "se",
};
/**
 * Dirección a partir de un vector de movimiento, en coordenadas de pantalla
 * (+y hacia abajo, así que +y es sur). Devuelve null si el vector es despreciable.
 */
export function facingFromVector(dx, dy) {
    if (Math.hypot(dx, dy) < 0.5)
        return null;
    const sector = Math.round(Math.atan2(dy, dx) / (Math.PI / 4));
    return FACINGS[(sector + 8) % 8];
}
/** Índice en FACINGS, para viajar por la red como un uint8. */
export function facingIndexFromVector(dx, dy) {
    const facing = facingFromVector(dx, dy);
    return facing === null ? null : FACINGS.indexOf(facing);
}
export function facingFromIndex(index) {
    return FACINGS[index] ?? FACINGS[DEFAULT_FACING_INDEX];
}
//# sourceMappingURL=facing.js.map